export default __webpack_public_path__ + "static/media/distance_marksheet_bg_1.b8e3de61.jpg";